import axios from 'axios';
import gorgias from '@/gen/gorgias';

export default {
  getSource(projectId, sourceId) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/sources/${sourceId}`;
    return axios.get(url);
  },

  listSources(projectId, sortBy = 'lastModifiedDate', sortDesc = [true], page = 0, itemsPerPage = 10) {
    if (sortBy.length === 0) {
      sortBy = 'lastModifiedDate';
    }

    if (sortDesc.length === 0) {
      sortDesc[0] = true;
    }
    const sortType = sortDesc[0] ? 'desc' : 'asc';

    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/sources?sort=${sortBy},${sortType}&page=${page}&pageSize=${itemsPerPage}`;
    return axios.get(url);
  },

  uploadSource(projectId, sourceVersion, sourceFile) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/sources?version=${sourceVersion}`;
    return axios.post(url, sourceFile, { headers: { 'Content-Type': 'application/octet-stream' } });
  },

  deleteSource(projectId, sourceId) {
    const url = `${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/sources/${sourceId}`;
    return axios.delete(url);
  },

  parseGorgias(source) {
    const start = Date.now()
    var result = gorgias.parse(source)
    const end = Date.now()
    console.log('Parse Duration: ' + (end - start) + ' ms')
    console.log(result)
    return result
  }
}